<template>
    <div class="filter-options">
        <v-layout row wrap pt-1>
            <v-flex xs12>
                <v-layout row wrap pt-1 pb-0>
                    <v-flex class="bold-font ypo_blue_color list-frame__title"
                            :data-qe-id="`${currentRibbon.key}_label`">
                        {{currentRibbon.label}}
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex pr-3>
                        <community-ribbon-action-buttons :current-ribbon="currentRibbon"
                                                         :handle-cancel="cancel"
                                                         :is-disabled="noFilterData"
                                                         :newly-selected-filter-number="newlySelectedFilterNumber"
                                                         :handle-apply="apply">
                        </community-ribbon-action-buttons>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout row wrap class="filter-options__filters" mt-3>
            <v-flex xs12 sm6 md4 lg3 pa-1 pr-2 v-for="(filter, index) in ribbonItemFromApi.filters"
                    v-if="showRibbonCheckboxOption(filter)"
                    :key="getRandomId(index)"
                class="filter-options__individual" >
                <label class="check-container ypo_blue_color"
                       v-if="!filter.isTypeAhead && (filter.subFilters && filter.subFilters.length === 0)">
                    <v-layout :class="isPreviouslySelected(filter, localFilterState) ? 'bold-font' : ''">
                        <v-flex class="check-container--label"
                                :data-qe-id="`${currentRibbon.key}_filter-${index}_label`">
                            {{filter.label}}
                        </v-flex>
                        <v-flex class="check-container--count"
                                :data-qe-id="`${currentRibbon.key}_filter-${index}_count`"
                                v-if="labelWithCount(filter, currentRibbon.key)">
                            {{labelWithCount(filter, currentRibbon.key)}}
                        </v-flex>
                    </v-layout>
                    <input type="checkbox"
                           :value="filter"
                           :data-qe-id="`${currentRibbon.key}_filter-${index}_checkbox`"
                           v-model="localFilterState">
                    <span class="checkmark"></span>
                </label>
                <community-filter-with-secondary-options
                        :current-filter-key="currentRibbon.key"
                        :filter-item="filter"
                        :filter-index="index"
                        :selected-filters-list="localFilterState"
                        :active-filter="activeFilter"
                        :set-current-secondary-options="setSecondaryFilterList"
                        v-if="!filter.isTypeAhead && filter.subFilters && filter.subFilters.length > 0">
                </community-filter-with-secondary-options>
            </v-flex>
        </v-layout>
        <v-layout column
                  v-if="communitySelectedSubFilter && communitySelectedSubFilter.length > 0"
                  class="filter-options__subFilters" pt-3>
            <v-flex xs12 class="filter-options__sub-label">
                {{secondaryFiltersLabel}}
            </v-flex>
            <v-flex xs12 pt-3>
                <v-layout class="filter-options__subFilters-options" row wrap>
                    <v-flex pa-2 xs12 sm6 md4 lg3 v-for="(subFilter, index) in communitySelectedSubFilter"
                            class="relative-position"
                            :key="getRandomId(index)">
                        <label class="check-container ypo_blue_color">
                            <v-layout :class="isPreviouslySelected(subFilter, localFilterState) ? 'bold-font' : ''" class="desktop-view-wrap">
                                <v-flex class="check-container--label"
                                        :data-qe-id="`${currentRibbon.key}_desktop_sub-filter-${index}_label`">
                                    {{subFilter.label}}
                                </v-flex>
                                <v-flex class="check-container--count"
                                        :data-qe-id="`${currentRibbon.key}_desktop_sub-filter-${index}_count`"
                                        v-if="labelWithCount(subFilter, currentRibbon.key)">
                                    {{labelWithCount(subFilter, currentRibbon.key)}}
                                </v-flex>
                            </v-layout>
                            <v-layout :class="isPreviouslySelected(subFilter, localFilterState) ? 'bold-font' : ''" class="mobile-view-wrap">
                                <v-flex class="check-container--label"
                                        :data-qe-id="`${currentRibbon.key}_mobile_sub-filter-${index}_label`">
                                    {{subFilter.label}}
                                <span class="check-container--count"
                                        :data-qe-id="`${currentRibbon.key}_mobile_sub-filter-${index}_count`"
                                        v-if="labelWithCount(subFilter, currentRibbon.key)">
                                    {{labelWithCount(subFilter, currentRibbon.key)}}
                                </span>
                                </v-flex>
                            </v-layout>
                            <input type="checkbox"
                                   :value="subFilter"
                                   :data-qe-id="`${currentRibbon.key}_sub-filter-${index}_checkbox`"
                                   v-model="localFilterState">
                            <span :class="['checkmark', isPreviouslySelected(subFilter, localFilterState) ? 'checked-box' : '']"></span>
                        </label>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { appCommonConstants } from "../appCommon.constants";
    import { getRandomId } from "../../common/utils/utils";
    import { storeGetters } from "../../store/storeGetters.constant";
    import {
        communityDirectoryPageConstant,
        subFiltersForRibbon,
    } from "./communityDirectoryPage.constants";
    import { isButtonEnabled, setLocalFilterData } from "@/components/EventDirectoryPage/eventDirectoryPage.constants";
    import CommunityRibbonActionButtons from "./CommunityRibbonActionButtons";
    import CommunityFilterWithSecondaryOptions from "./CommunityFilterWithSecondaryOptions";

    export default {
        name: "Focus",
        components: { CommunityRibbonActionButtons, CommunityFilterWithSecondaryOptions },
        created() {
            const filtersFromRoute = this.$route.query.communityFilters ? JSON.parse(this.$route.query.communityFilters) : null;
            if (filtersFromRoute && this.currentRibbon) {
                this.localFilterState = setLocalFilterData(filtersFromRoute[this.currentRibbon.key], this.ribbonItemFromApi);
            }
        },
        data() {
            return {
                appCommonConstants,
                localFilterState: [],
                activeFilter: {},
                communitySelectedSubFilter: null,
            };
        },
        props: {
            currentRibbon: {
                type: Object,
                required: true,
            },
            postAction: {
                type: Function,
                required: true,
            },
            ribbonItemFromApi: {
                type: Object,
                required: true,
            },
            isPreviouslySelected: {
                type: Function,
                required: true,
            },
            labelWithCount: {
                type: Function,
                required: true,
            },
            showRibbonCheckboxOption: {
                type: Function,
                required: true,
            },
            updateRoute: {
                type: Function,
                required: true,
            },
            applyNumberCount: {
                type: Function,
                required: true,
            },
        },
        methods: {
            ...mapActions({
                getCommunityDirectoryResults: `communityDirectory/${storeAction.getCommunityDirectoryResults}`,
            }),
            ...mapMutations({
                setCommunityStateFromRouter: `communityDirectory/${storeMutation.setCommunityStateFromRouter}`,
            }),
            getRandomId,
            cancel() {
                this.postAction();
            },
            apply() {
                this.updateRoute(this.currentRibbon.key, this.localFilterState);
                this.getCommunityDirectoryResults();
                this.postAction();
            },
            noFilterData() {
                return isButtonEnabled(this.communitySelectedFilters[this.currentRibbon.key], this.localFilterState);
            },
            setSecondaryFilterList(filter) {
                this.communitySelectedSubFilter = filter.subFilters && filter.subFilters.length
                    ? filter.subFilters
                    : null;
                this.activeFilter = filter;
            },
        },
        computed: {
            ...mapGetters({
                communitySelectedFilters: `communityDirectory/${storeGetters.communitySelectedFilters}`,
            }),
            newlySelectedFilterNumber() {
                return this.applyNumberCount(this.localFilterState);
            },
            previouslySelected() {
                return this.communitySelectedFilters && this.currentRibbon ? this.communitySelectedFilters[this.currentRibbon.key] : [];
            },
            secondaryFiltersLabel() {
                let secondaryLabel = communityDirectoryPageConstant.label.SECONDARY_FILTER_LABEL_DEFAULT;
                if (this.activeFilter && this.activeFilter.filterKey) {
                    const l = subFiltersForRibbon.find(item => item.key === this.activeFilter.filterKey);
                    if (l) {
                        secondaryLabel = l.label;
                    }
                }
                return secondaryLabel;
            },
        },
    };
</script>


<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_commonClasses.scss';

    .list-frame {
        &__title {
            padding-left: 20px;
            margin-top: 13px;
            text-align: left;
        }

        &__actions {
            padding-right: 13px;
        }
    }
    .filter-options {
        background-color: $ypo-extra-light-gray;
        @extend %ypo_checkbox;
        @include mobile-view-wrap;
        @include desktop-view-wrap;
        @include ellipse-handler;

        &__filters {
            background-color: $white;
            padding: 20px 40px 15px;
            margin: 5px 20px 20px;
        }

        &__subFilters {
            padding: 15px 20px 20px;

            &-options {
                background-color: $white;
                padding: 20px 40px;
            }
        }

        &__sub-label {
            color: $ypo-blue;
            font-family: "Noto Sans", sans-serif;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0.23px;
            line-height: 24px;
        }

        .private_networks {
            font-size: 16px;
            letter-spacing: -0.01px;
            line-height: 22px;
        }

        .blocked-filter {
            position: absolute;
            height: 100%;
            width: 100%;
            z-index: 2;
            left: -1px;
            background-color: transparent;
        }

        .checked-box {
            &:after{
                display: block;
                left: 5px;
                top: 1px;
                width: 5px;
                height: 12px;
                border: solid $ypo-cta;
                border-width: 0 3px 3px 0;
                -webkit-transform: rotate(45deg);
                transform: rotate(45deg)
            }
        }
    }

</style>

